import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { getBonusMessagesHandler, getStatusHandler } from "../../../constants";
import { parseSettlementStatus } from "../../parseSettlementStatus";
const mapBetStatusToQualifyingBetStatus = new Proxy({
    Open: "Active",
    Won: "Active",
    Lost: "Inactive",
    CashOut: "Inactive",
    Cancelled: "Inactive",
    DeadHeatReduction: "Active",
    Void: "Inactive",
}, getStatusHandler);
const mapBetStatusToQualifyingBetPhrases = new Proxy({
    Open: [],
    Won: [],
    Lost: [],
    CashOut: ["QualifyingBetCashedOut"],
    Cancelled: ["QualifyingBetReturned"],
    DeadHeatReduction: [],
    Void: ["QualifyingBetReturned"],
}, getBonusMessagesHandler);
export function parseQualifyingBetBonusMessagesAndState(bet, dictionary) {
    var _a, _b;
    const settlementStatus = parseSettlementStatus(bet.settlementStatus);
    const bonusStatus = (((_a = bet.bonus) === null || _a === void 0 ? void 0 : _a.qualifyingBetType) === "No Sweat" || ((_b = bet.bonus) === null || _b === void 0 ? void 0 : _b.qualifyingBetType) === "Second Chance") && settlementStatus === "Lost" ? "Active" : mapBetStatusToQualifyingBetStatus[settlementStatus];
    const bonusMessages = mapBetStatusToQualifyingBetPhrases[settlementStatus].map(phrase => {
        var _a;
        return ({
            type: "Regular",
            text: dictionary.myBetsDictionary[phrase].replace("{0}", getTruthyValue((_a = bet.bonus) === null || _a === void 0 ? void 0 : _a.qualifyingBetType, ""))
        });
    });
    return [bonusStatus, bonusMessages];
}
//# sourceMappingURL=parseQualifyingBetBonusMessagesAndState.js.map